/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountDeactivationReasonEnum {
  FOUND_MATCH_ELSEWHERE = "FOUND_MATCH_ELSEWHERE",
  FOUND_MATCH_HERE = "FOUND_MATCH_HERE",
  NO_LONGER_PROVIDER = "NO_LONGER_PROVIDER",
  NO_LONGER_SEEKER = "NO_LONGER_SEEKER",
  NO_SUITABLE_MATCHES = "NO_SUITABLE_MATCHES",
  OTHER = "OTHER",
  TOO_EXPENSIVE = "TOO_EXPENSIVE",
  UNSOLICTED_MESSAGES = "UNSOLICTED_MESSAGES",
}

export enum AuthStateEnum {
  AUTO_LOGGED_IN = "AUTO_LOGGED_IN",
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
  NOTIFICATIONS_UNSUBSCRIBE = "NOTIFICATIONS_UNSUBSCRIBE",
}

export enum BusinessModelEnum {
  ACTIVE_JOBS = "ACTIVE_JOBS",
  LIMITED_APPLICATIONS = "LIMITED_APPLICATIONS",
  STANDARD = "STANDARD",
  VIP = "VIP",
}

export enum CreditPeriodEnum {
  day = "day",
  week = "week",
}

/**
 * The type of paywall the user is seeing
 */
export enum MessagePaywallType {
  FIRST_REPLY = "FIRST_REPLY",
  MESSAGE = "MESSAGE",
}

/**
 * The reason for marking a conversation as spam
 */
export enum SpamTypeEnum {
  AGGRESSIVE = "AGGRESSIVE",
  INAPPROPRIATE = "INAPPROPRIATE",
  IRRELEVANT = "IRRELEVANT",
  OTHER = "OTHER",
  SCAM = "SCAM",
}

/**
 * The origin platform for the user
 */
export enum UserPlatformEnum {
  CG = "CG",
  HP = "HP",
  USN = "USN",
}

/**
 * One of 'PROVIDER' or 'SEEKER'
 */
export enum UserTypeEnum {
  PROVIDER = "PROVIDER",
  SEEKER = "SEEKER",
}

export enum WageTypeEnum {
  daily_rate = "daily_rate",
  hourly_rate = "hourly_rate",
}

/**
 * Autogenerated input type of ConnectToFacebook
 */
export interface ConnectToFacebookInput {
  fbAccessToken: string;
  fbUid: string;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of ConnectToGoogle
 */
export interface ConnectToGoogleInput {
  idToken: string;
  googleUserId: string;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of CreateListing
 */
export interface CreateListingInput {
  isProviderListing: boolean;
  name: string;
  description: string;
  cityId: string;
  origin: string;
  services?: string[] | null;
  workEligibilitySponsorshipRequired?: boolean | null;
  wageInfo?: string | null;
  wageType?: WageTypeEnum | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of CreateUser
 */
export interface CreateUserInput {
  email: any;
  origin?: string | null;
  password?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: any | null;
  userType?: UserTypeEnum | null;
  platform?: UserPlatformEnum | null;
  avatarAssembly?: string | null;
  facebookUserId?: string | null;
  googleUserId?: string | null;
  timeZone?: string | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of DeactivateAccount
 */
export interface DeactivateAccountInput {
  reason: AccountDeactivationReasonEnum;
  otherReason?: string | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of SendMessage
 */
export interface SendMessageInput {
  conversationId?: string | null;
  listingId?: string | null;
  userId?: string | null;
  message: string;
  isResume?: boolean | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of UpdateUser
 */
export interface UpdateUserInput {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: any | null;
  currentPassword?: string | null;
  newPassword?: string | null;
  confirmPassword?: string | null;
  clientMutationId?: string | null;
}

export interface directoryParams {
  page?: number | null;
  type: string;
  location?: locationParam | null;
  search?: string | null;
  selectedFacets?: (string | null)[] | null;
  selectedProviderTypes?: (string | null)[] | null;
  useNear?: boolean | null;
  selectedLanguageId?: number | null;
  ipAddress?: string | null;
}

/**
 * Location parameter
 */
export interface locationParam {
  country?: string | null;
  state?: string | null;
  city?: string | null;
  neighborhood?: string | null;
  postalCode?: string | null;
  range?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
